import { useHidePriceTypes, useOffersModules, useTelesalesCustomerNumber } from "@tm/context-distribution"
import Morpheus from "@tm/morpheus"
import { Dictionary, useExternalCatalogUrl } from "@tm/utils"
import { useCallback, useEffect, useMemo, useState } from "react"
import { ListOptions } from "@tm/models"
import { usePartsViewOptions } from "@bundles/parts/components/ListV2/hooks"
import { useCarouselConfigurationContext } from ".."

export function useCarouselOptions(): ListOptions {
    const { addToBasketExternalSystemId } = Morpheus.getParams("basket")
    const { isPriceTypeHidden } = useHidePriceTypes()
    const { telesalesCustomerNo } = useTelesalesCustomerNumber()
    const { externalCatalogUrl } = useExternalCatalogUrl({
        externalSystemId: addToBasketExternalSystemId,
        telesalesCustomerNo,
    })
    const { showDataSupplierLogos, hasFavoriteArticles, hideAddToBasketButton, highlightWatchlistButton, erpDataCustomization } =
        useCarouselConfigurationContext()

    const { showPurchasePrice, partsViewSettings } = usePartsViewOptions()
    const { showArticleImages, compactView } = partsViewSettings

    const { hasOfferCarouselModuleTileView } = useOffersModules()
    const [expandedArticleIds, setExpandedArticleIds] = useState<Dictionary<boolean>>({})

    useEffect(() => {
        setExpandedArticleIds({})
    }, [compactView, hasOfferCarouselModuleTileView])

    const setExpandedArticleId = useCallback(
        (articleId: string) => {
            if (hasOfferCarouselModuleTileView) {
                setExpandedArticleIds((prev) => {
                    if (prev[articleId]) {
                        return {}
                    }
                    return { [articleId]: true }
                })
                return
            }

            setExpandedArticleIds((prev) => {
                return { ...prev, [articleId]: !prev[articleId] }
            })
        },
        [hasOfferCarouselModuleTileView]
    )

    return useMemo<ListOptions>(
        () => ({
            showDocumentsInline: false,
            showDocumentsInCompact: false,
            openDocumentsAsModal: true,
            showReferenceLinksInCompact: false,
            showDataSupplierLogos,
            externalCatalogUrl,
            hasFavoriteArticles,
            hideCostEstimationButton: true,
            hideAddToBasketButton,
            highlightFavoriteArticlesButton: highlightWatchlistButton,
            showPurchasePrice,
            showArticleImages,
            isPriceTypeHidden,
            compactView,
            tileView: hasOfferCarouselModuleTileView,
            erpDataCustomization,
            hideSelection: true,
            setExpandedArticleId,
            expandedArticleIds,
        }),
        [
            showDataSupplierLogos,
            externalCatalogUrl,
            hasFavoriteArticles,
            hideAddToBasketButton,
            highlightWatchlistButton,
            showPurchasePrice,
            showArticleImages,
            isPriceTypeHidden,
            compactView,
            hasOfferCarouselModuleTileView,
            erpDataCustomization,
            setExpandedArticleId,
            expandedArticleIds,
        ]
    )
}
